import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppSharedModule } from 'app/app-shared.module';
import { EditLabelPopoutComponent } from 'app/components/edit-label-popout/edit-label-popout.component';
import { FileUploadComponent } from 'app/components/file-upload/file-upload.component';
import { ImportDialogComponent } from 'app/components/import-dialog/import-dialog.component';
import { ItemLabelComponent } from 'app/components/item-label/item-label.component';
import { ItemLabelsComponent } from 'app/components/item-labels/item-labels.component';
import { AuthGuardService } from 'app/providers/bridge-api/auth.service';
import { GroupRouteGuardService } from 'app/services/group-route-guard.service';
import { ConfigurationTableComponent } from '../configuration/components/configuration-table/configuration-table.component';
import { DashboardDatasourceFilterPillComponent } from '../dashboard/components/dashboard-datasource-rules/dashboard-datasource-filter-pill/dashboard-datasource-filter-pill.component';
import { DashboardDatasourceRulesModalComponent } from '../dashboard/components/dashboard-datasource-rules/dashboard-datasource-rules-modal.component';
import { UploadCreateDialogComponent } from '../upload/components/upload-create/upload-create.component';
import { NewAnalysisGroupComponent } from './components/new-analysis-group/new-analysis-group.component';

import { NotesEditorComponent } from './components/notes-editor/notes-editor.component';
import { ProjectAboutComponent } from './components/project-about/project-about.component';
import { ProjectCollectionActionsComponent } from './components/project-collection-actions/project-collection-actions.component';
import { ProjectCreateDialogComponent } from './components/project-create/project-create.component';
import { ProjectDashboardActionsComponent } from './components/project-dashboard-actions/project-dashboard-actions.component';
import { MapProjectItemToLabelPipe } from './components/project-details-item-panel/map-project-item-to-label.pipe';
import { ProjectDetailsItemPanelComponent } from './components/project-details-item-panel/project-details-item-panel.component';
import { ProjectDetailsTableLabelsComponent } from './components/project-details-table/project-details-table-labels/project-details-table-labels.component';
import { ProjectDetailsTableComponent } from './components/project-details-table/project-details-table.component';
import { TableDocCountPipe } from './components/project-details-table/table-doc-count.pipe';
import { ProjectGroupActionsComponent } from './components/project-group-actions/project-group-actions.component';
import { ProjectIconComponent } from './components/project-icon/project-icon.component';
import { ProjectIconSelectorDialogComponent } from './components/project-icon-selector/project-icon-selector.component';
import { ColorBoxComponent } from './components/project-options-drawer/color-box/color-box.component';
import { ColorPaletteImportDialogComponent } from './components/project-options-drawer/color-palette-import-dialog/color-palette-import-dialog.component';
import { ProjectOptionsDrawerComponent } from './components/project-options-drawer/project-options-drawer.component';
import { ProjectSentimentRangeComponent } from './components/project-sentiment-range/project-sentiment-range.component';
import { ReAnalyzeModalComponent } from './components/reanalyze-modal/reanalyze-modal.component';
import { RenameAnalysisGroupComponent } from './components/rename-analysis-group/rename-analysis-group.component';
import { ShareDashboardDialogComponent } from './components/share-dashboard-dialog/share-dashboard-dialog.component';
import { SpotlightDashboardIdeasDialogComponent } from './components/spotlight-dashboard-ideas-dialog/spotlight-dashboard-ideas-dialog.component';
import { ProjectListComponent } from './pages/project-list/project-list.component';
import { ProjectViewComponent } from './pages/project-view/project-view.component';

@NgModule({
  imports: [
    AppSharedModule,
    ImportDialogComponent,
    FileUploadComponent,
    ProjectCollectionActionsComponent,
    ColorBoxComponent,
    ColorPaletteImportDialogComponent,
    NgbModule,
    NgxSliderModule,
    UploadCreateDialogComponent,
    NotesEditorComponent,
    ItemLabelComponent,
    ProjectDetailsTableLabelsComponent,
    ItemLabelsComponent,
    EditLabelPopoutComponent,
    DashboardDatasourceRulesModalComponent,
    DashboardDatasourceFilterPillComponent,
    NewAnalysisGroupComponent,
    TableDocCountPipe,
    SpotlightDashboardIdeasDialogComponent,
    MapProjectItemToLabelPipe,
    ConfigurationTableComponent,
    RouterModule.forRoot(
      [
        {
          canActivate: [AuthGuardService, GroupRouteGuardService],
          path: 'groups/:groupId/projects',
          component: ProjectListComponent,
          children: [
            {
              path: ':projectId',
              component: ProjectViewComponent,
            },
          ],
        },
      ],
      {}
    ),
  ],
  providers: [],
  declarations: [
    ProjectListComponent,
    ProjectCreateDialogComponent,
    ProjectIconSelectorDialogComponent,
    ProjectViewComponent,
    ProjectSentimentRangeComponent,
    ProjectOptionsDrawerComponent,
    ShareDashboardDialogComponent,
    ProjectOptionsDrawerComponent,
    ProjectIconComponent,
    ProjectDetailsTableComponent,
    ProjectDetailsItemPanelComponent,
    ProjectAboutComponent,
    ProjectDashboardActionsComponent,
    ProjectGroupActionsComponent,
    ReAnalyzeModalComponent,
    RenameAnalysisGroupComponent,
  ],
  exports: [ProjectListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProjectModule {}
